// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-mobile-overflow[data-v-78029bce] {\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.card[data-v-78029bce] {\n  position: relative;\n}\n.picker[data-v-78029bce] {\n  border: 3px dashed var(--v-secondary-lighten5);\n  cursor: pointer;\n}\n.close[data-v-78029bce] {\n  position: absolute;\n  top: 0;\n  right: 0;\n}", ""]);
// Exports
module.exports = exports;
